module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/gifts/gift_blue_04-10ae76db764a36017f180b3a6414deb6.svg";